import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import Pager, { usePager } from "@/components/Pager";

export default function AdminPaymentsPage() {
  const [items, setItems] = useState([]);
  const pager = usePager(items, 20);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const r = await api.get("/admin/payments");
    setItems(r.data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const markPaid = async (id) => {
    if (!window.confirm("Manually mark as paid?")) return;
    try {
      await api.post(`/admin/payments/${id}/mark-paid`, { note: "Manual override" });
      toast.success("Marked as completed");
      load();
    } catch (e) { toast.error("Failed"); }
  };

  return (
    <div data-testid="admin-payments-page">
      <div className="kb-mono text-[10px] uppercase tracking-[0.2em] text-kb-ink-muted">PAYMENTS</div>
      <h1 className="font-serif text-3xl lg:text-4xl text-kb-ink mt-1">All <em className="italic text-kb-primary">transactions</em></h1>

      <div className="mt-8 border border-slate-200 rounded-sm bg-white overflow-hidden">
        <div className="grid grid-cols-12 px-4 lg:px-6 py-3 border-b border-slate-200 bg-slate-50 kb-mono text-[10px] uppercase tracking-wider text-kb-ink-muted">
          <div className="col-span-2">Date</div>
          <div className="col-span-2">User</div>
          <div className="col-span-3">Title</div>
          <div className="col-span-1">Context</div>
          <div className="col-span-1">Provider</div>
          <div className="col-span-1">Amount</div>
          <div className="col-span-1">Status</div>
          <div className="col-span-1 text-right">Action</div>
        </div>
        {loading ? <div className="p-6 kb-mono text-xs text-kb-ink-muted">Loading…</div> :
          items.length === 0 ? <div className="p-10 text-center text-sm text-kb-ink-muted">No payments yet.</div> :
          pager.pageItems.map((p) => (
            <div key={p.id} className="grid grid-cols-12 px-4 lg:px-6 py-3 border-b border-slate-200 last:border-0 items-center text-sm" data-testid={`admin-payment-${p.id}`}>
              <div className="col-span-12 lg:col-span-2 kb-mono text-[11px] text-kb-ink-muted">
                {p.created_at ? new Date(p.created_at).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "—"}
              </div>
              <div className="col-span-12 lg:col-span-2 text-kb-ink truncate">{p.user_name}</div>
              <div className="col-span-12 lg:col-span-3 text-kb-ink truncate" title={p.title}>{p.title || "—"}</div>
              <div className="col-span-6 lg:col-span-1 kb-mono text-[10px] text-kb-ink-muted truncate">{p.context_type}</div>
              <div className="col-span-6 lg:col-span-1 kb-mono text-xs">{p.provider}</div>
              <div className="col-span-6 lg:col-span-1 font-mono text-kb-primary whitespace-nowrap">NPR {Number(p.amount_npr).toLocaleString()}</div>
              <div className="col-span-6 lg:col-span-1">
                <span className={`kb-mono text-[10px] uppercase tracking-wider px-2 py-1 rounded-sm ${
                  p.status === "completed" ? "text-emerald-700 bg-emerald-50" :
                  p.status === "pending" ? "text-amber-700 bg-amber-50" :
                  "text-rose-700 bg-rose-50"
                }`}>{p.status}</span>
              </div>
              <div className="col-span-12 lg:col-span-1 text-right">
                {p.status !== "completed" && (
                  <button onClick={() => markPaid(p.id)} className="kb-mono text-[10px] text-kb-primary" data-testid={`mark-paid-${p.id}`}>MARK PAID</button>
                )}
              </div>
            </div>
          ))}
      </div>
      <Pager {...pager} label="payments" testId="admin-payments-pager" />
    </div>
  );
}